export default __webpack_public_path__ + "static/media/property_186.75086b84.png";